<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink>
        <div class="c-avatar">
          <img src="img/avatars/user-icon.jpg" class="c-avatar-img" />
        </div>
      </CHeaderNavLink>
    </template>
    <CDropdownHeader tag="div" class="text-center" color="light">
      <strong>ユーザ</strong>
    </CDropdownHeader>
    <!-- 
    <CDropdownItem>
      <CIcon name="cil-bell"/> Updates
      <CBadge color="info" class="mfs-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem>
    <CDropdownItem>
      <CIcon name="cil-envelope-open" /> Messages
      <CBadge color="success" class="mfs-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem>
    <CDropdownItem>
      <CIcon name="cil-task" /> Tasks
      <CBadge color="danger" class="mfs-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem>
    <CDropdownItem>
      <CIcon name="cil-comment-square" /> Comments
      <CBadge color="warning" class="mfs-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem>
    <CDropdownHeader
      tag="div"
      class="text-center"
      color="light"
    >
      <strong>Settings</strong>
    </CDropdownHeader>
    <CDropdownItem>
      <CIcon name="cil-user" /> Profile
    </CDropdownItem>
    <CDropdownItem>
      <CIcon name="cil-settings" /> Settings
    </CDropdownItem>
    <CDropdownItem>
      <CIcon name="cil-dollar" /> Payments
      <CBadge color="secondary" class="mfs-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem>
    <CDropdownItem>
      <CIcon name="cil-file" /> Projects
      <CBadge color="primary" class="mfs-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem>
    <CDropdownDivider/>
    <CDropdownItem>
      <CIcon name="cil-lock-locked" /> Lock Account
    </CDropdownItem>
 -->
    <CDropdownItem @click="manualClick">
      <CIcon name="cil-spreadsheet" /> 利用者マニュアル
      <CBadge color="primary" class="mfs-auto" />
    </CDropdownItem>
    <div v-if="authority_id === 0">
      <CDropdownItem @click="manualManegeClick">
         <CIcon name="cil-settings" /> 管理者マニュアル
        <CBadge color="primary" class="mfs-auto" />
      </CDropdownItem>
    </div>
    <CDropdownItem @click="infoClick">
      <CIcon name="cil-spreadsheet" /> 問い合わせ
      <CBadge color="primary" class="mfs-auto" />
    </CDropdownItem>
    <CDropdownItem @click="logoutClick">
      <CIcon name="cil-account-logout" /> ログアウト
      <CBadge color="primary" class="mfs-auto" />
    </CDropdownItem>
  </CDropdown>
</template>

<script>
export default {
  name: "TheHeaderDropdownAccnt",
  data() {
    return {
      itemsCount: 42,
      authority_id: "",
    };
  },
  mounted() {
    this.authority_id = this.$store.state.loginUser.authority_id;
  },
  methods: {
    //ログアウト処理
    logoutClick() {
      this.$store.dispatch("auth", {
        loginUser: [],
        islogin: false,
      });
      //ログイン画面遷移
      if (process.env.VUE_APP_IS_ADLOGIN === "true") {
        document.location.href = "/auth/logout";
      } else {
        this.$router.push({ name: "Login" });
      }
    },
    //マニュアルクリック
    manualClick() {
      window.open("/manual/index.html", "_blank");
    },
    //管理者マニュアル
    manualManegeClick() {
      window.open("/maintenancemanual/index.html", "_blank");  
    },
    // 問い合わせ
    infoClick() {
      window.open("https://forms.office.com/Pages/ResponsePage.aspx?id=c0YozPoRMUKeAjB1vT8eHQ5Npa6BxPNMrXYWfE5rfUlUOTIzNDhINzNLM1VCWkVTQUtOUUVXUDFMSyQlQCN0PWcu")
    }
  },
};
</script>

<style scoped>
.c-icon {
  margin-right: 0.3rem;
}
</style>